import styled from 'styled-components'

export const SocialWrapper = styled.div ` 
    background: none;
    padding: 20px;

    .linkedin{
        color: #999;
        background: none;
        padding: 8px;
        transition: color 1s;

     &:hover{
            color:#0077B5;
        }
    }
    .whatsapp{
        color: #999;
        background: none;
        padding: 8px;
        transition: color 1s;

     &:hover{
            color:#00E676;
        }
    }
    .github{
        color: #999;
        background: none;
        padding: 8px;
        transition: color 1s;

     &:hover{
            color:#222;
        }
    }
    .instagram{
        color: #999;
        background: none;
        padding: 8px;
        transition: color 1s;

     &:hover{
            color: #e1306c;
        }
    }
    
    

`
